<span class="badge bg-danger dev-warning" *ngIf="!production">Development Environment</span>
<div class="progress-wrapper" *ngIf="loading">
  <ngb-progressbar type="primary" [value]="progress" height="4px"></ngb-progressbar>
</div>
<!-- <div *ngIf="workspaceExpiryActive" class="workspace-expiry-side-panel">
  <div class="workspace-expiry-side-panel__content">
    <div class="d-flex align-items-center gap-2">
      <i class="fa fa-exclamation-circle text-danger"></i>
      <div>
        <strong>Workspace expired</strong>
        <div class="small text-muted">{{ workspaceExpiryMessage }}</div>
      </div>
    </div>
    <div class="mt-3 text-end">
      <button type="button" class="btn btn-sm btn-danger" (click)="logout()">
        Logout
      </button>
    </div>
  </div>
</div> -->


<!-- <div
  *ngIf="workspaceExpiryActive && workspaceExpiryBannerVisible"
  class="workspace-expiry-banner alert alert-warning alert-dismissible fade show"
  role="alert"
>
  <div class="d-flex align-items-start">
  <div class="me-3 mt-1vd-flex-shrink-0 gap-2">
      <i class="fa fa-exclamation-triangle ml-3 text-danger"></i>
    </div>
    <div class="flex-grow-1">
      <strong>Workspace expired.</strong>
      <div class="small mt-1 text-danger">{{ workspaceExpiryMessage }}</div>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeWorkspaceExpiryBanner()"
    >X</button>
  </div>
</div> -->
<ng-container>
  <!-- <ng-container *z -->

  <ng-container *ngIf="coreConfig.layout.type === 'horizontal'">
    <horizontal-layout></horizontal-layout>
  </ng-container>
  <!-- <core-sidebar name="themeCustomizer" class="customizer d-none d-md-block" *ngIf="coreConfig.layout.customizer">
    <a class="customizer-toggle d-flex align-items-center justify-content-center"
      (click)="toggleSidebar('themeCustomizer')">
      <span [data-feather]="'settings'" [class]="'spinner'"></span>
    </a>
    <core-theme-customizer></core-theme-customizer>
  </core-sidebar> -->

  <!-- <ng-container *renderIf="{ roles: ['employee'] }"> -->
  <ng-template #dueTasksModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
      <div class="row">
        <div class="col-12">
          <h4 class="text-center" style="font-weight: bold" *ngIf="!dueTaskLoading">
            You've missed the deadlines of these tasks, please tell us why
            didn't you completed them?
          </h4>
          <div class="table-responsive mt-2">
            <table class="table">
              <thead>
                <tr>
                  <th>Task</th>
                  <th>Due Date</th>
                  <th>Priority</th>
                  <th></th>
                </tr>
              </thead>

              <tbody *ngFor="let task of dueTasks">
                <tr style="vertical-align: middle">
                  <td style="width: 390px">
                    <span class="my-des alt" [innerText]="task.title"></span>
                  </td>
                  <td>{{ task.dueDate }}</td>
                  <td>{{ task.priority | uppercase }}</td>
                  <td class="mars-actions-td alt">
                    <span class="waves-effect btn-flat-secondary" (click)="task.expand = !task.expand">
                      <mat-icon [fontIcon]="
                          task.expand ? 'keyboard_arrow_down' : 'chevron_right'
                        "></mat-icon>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="p-0">
                    <div [ngbCollapse]="!task.expand">
                      <quill-editor class="w-100" placeholder="Your reason here..."
                        [(ngModel)]="this.values[task.id].value">
                        <div quill-editor-toolbar>
                          <span class="ql-formats">
                            <button class="ql-bold" [title]="'Bold'"></button>
                            <button class="ql-italic" [title]="'italic'"></button>
                            <button class="ql-underline" [title]="'underline'"></button>
                          </span>
                          <span class="ql-formats">
                            <select class="ql-align" [title]="'Alignment'">
                              <option selected></option>
                              <option value="center"></option>
                              <option value="right"></option>
                              <option value="justify"></option>
                            </select>
                          </span>
                          <span class="ql-formats">
                            <button class="ql-list" value="ordered" type="button"></button>
                          </span>
                          <span class="ql-formats">
                            <button class="ql-formula" value="ordered" type="button"></button>
                            <button class="ql-code-block" value="ordered" type="button"></button>
                          </span>
                          <span class="ql-formats">
                            <button class="ql-clean" value="ordered" type="button"></button>
                          </span>
                        </div>
                      </quill-editor>
                      <span class="text-danger" *ngIf="this.values[task.id].error">Please give a reason...</span>
                      <div class="col-12 text-right px-0 py-1">
                        <button class="btn btn-primary btn-sm" (click)="submit(task.id)"
                          [disabled]="this.values[task.id].loading">
                          <div class="spinner-border spinner-border-sm mr-50" role="status"
                            *ngIf="this.values[task.id].loading">
                            <span class="sr-only">Loading...</span>
                          </div>
                          Submit
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- </ng-container> -->
</ng-container>

<ng-template #workspaceExpiryModal let-modal>
  <!-- <div class="modal-header">
    <h4 class="modal-title" id="workspaceExpiryModalLabel">
      {{ isWorkspaceExpired ? 'Workspace Expired' : 'Workspace Expiry Notice' }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeWorkspaceExpiryModal(modal)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->

  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center py-2">
        <div class="workspace-expiry-icon-container mb-3" [class.expired]="isWorkspaceExpired">
          <mat-icon *ngIf="!isWorkspaceExpired" class="workspace-expiry-icon">hourglass_empty</mat-icon>
          <mat-icon *ngIf="isWorkspaceExpired" class="workspace-expiry-icon">warning</mat-icon>
        </div>

        <p class="text-muted fs-6 mb-3">
          Your workspace <span class="badge badge-light-info" *ngIf="workspaceExpiry?.workspaceType">{{
            workspaceExpiry?.workspaceType }}</span> subscription details for <strong class="text-primary">{{
            workspaceExpiry?.name }}</strong>:
        </p>

        <div class="workspace-expiry-time-box p-3 mb-3 rounded-3 d-inline-block w-100"
          [class.expired]="isWorkspaceExpired">
          <span class="d-block text-uppercase small tracking-wider mb-1" [class.text-danger]="isWorkspaceExpired"
            [class.text-warning]="!isWorkspaceExpired">
            {{ isWorkspaceExpired ? 'Status' : 'Remaining Time' }}
          </span>
          <h2 class="fw-bolder m-0" [class.text-danger]="isWorkspaceExpired" [class.text-warning]="!isWorkspaceExpired">
            {{ isWorkspaceExpired ? 'Expired' : workspaceExpiryTimeStr }}
          </h2>
        </div>



        <p class="small text-secondary mb-0" *ngIf="workspaceExpiryDate">
          Expiry Date: {{ workspaceExpiryDate | date:'mediumDate' }}
        </p>

        <div *ngIf="isWorkspaceExpired || workspaceExpiryActive" class="alert alert-danger mt-2 mb-0">
          <ng-container *ngIf="workspaceExpiryMessage; else defaultWorkspaceExpiryMessage">
            {{ workspaceExpiryMessage }}
          </ng-container>
          <ng-template #defaultWorkspaceExpiryMessage>
            Your workspace has expired. Please contact
            <a href="">Info@innovador.solutions.com</a>
            for assistance.
          </ng-template>
        </div>


      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary px-4" (click)="closeWorkspaceExpiryModal(modal)">
      Got it
    </button>
  </div>
</ng-template>


<ng-template #releaseNotesModal let-modal>
  <div class="modal-dialog modal-dialog-centered modal-lg release-notes-modal">
    <div class="modal-content">
      <div class="modal-header border-0">
        <div>
          <h4 class="modal-title fw-semibold text-primary">
            What’s New <span class="ms-1">🎉</span>
          </h4>
          <small class="text-muted"> Latest updates and improvements </small>
        </div>

        <button type="button" class="release-notes-close-btn" aria-label="Close" (click)="markReleaseNotesSeen(modal)">
          <i data-feather="x"></i>
        </button>
      </div>
      <div class="modal-body release-notes-body">
        <div class="release-notes-content p-3 rounded-3 bg-light">
          <div [innerHTML]="activeReleaseNote?.content"></div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button class="btn btn-primary px-4" (click)="markReleaseNotesSeen(modal)">
          Got it
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- <ng-template #releaseNotesModal let-modal>
  <div class="modal-header border-0">
    <div>
      <h4 class="modal-title fw-semibold text-primary">
        What’s New <span class="ms-1">🎉</span>
      </h4>
      <small class="text-muted">Latest updates and improvements</small>
    </div>

    <button
      type="button"
      class="release-notes-close-btn"
      aria-label="Close"
      (click)="markReleaseNotesSeen(modal)"
    >
      <i data-feather="x"></i>
    </button>
  </div>

  <div class="modal-body release-notes-body">
    <div class="release-notes-content p-3 rounded-3 bg-light">
      <div [innerHTML]="activeReleaseNote?.content"></div>
    </div>
  </div>

  <div class="modal-footer border-0">
    <button class="btn btn-primary px-4" (click)="markReleaseNotesSeen(modal)">
      Got it
    </button>
  </div>
</ng-template> -->
  <div class="onboarding-floating-widget" *ngIf="onboardingService.isOnboardingRequired">
    
    <!-- Collapsed State -->
    <div class="widget-collapsed shadow" 
         *ngIf="!onboardingWidgetExpanded" 
         (click)="toggleOnboardingWidget()">
      <div class="collapsed-icon-wrapper">
        <i class="feather icon-target"></i>
      </div>
    </div>

    <!-- Expanded State (Matches Screenshot) -->
    <div class="widget-expanded shadow-lg" *ngIf="onboardingWidgetExpanded">
      
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-1">
        <h5 class="fw-bolder m-0" style="color: #1E1E2D;">Setup Progress</h5>
        <i class="feather icon-x cursor-pointer text-muted" (click)="toggleOnboardingWidget()" style="font-size: 18px;"></i>
      </div>
      
      <!-- Progress Info -->
      <div class="mb-50 mt-1">
        <h4 class="fw-bolder mb-0" style="color: #1E1E2D;">{{ onboardingService.onboardingProgress }}% complete</h4>
        <span style="font-size: 11px;">{{ onboardingService.currentStep + 1 }} of {{ onboardingService.steps.length }} setup steps</span>
      </div>

      <!-- Progress Bar -->
      <div class="progress mb-2" style="height: 6px; border-radius: 10px; background-color: #f3f2f7;">
        <div class="progress-bar" role="progressbar" 
             [style.width.%]="onboardingService.onboardingProgress" 
             style="background-color: #7367f0; border-radius: 10px;">
        </div>
      </div>

      <!-- Next Steps Title -->
      <h6 class="fw-bolder mb-1 mt-1" style="color: #1E1E2D; font-size: 13px;">Next steps</h6>
      
      <!-- Stepper List -->
      <div class="stepper-wrapper mb-2 custom-widget-stepper">
        <ng-container *ngFor="let step of onboardingService.steps; let i = index">
          <div #stepItem class="stepper-item d-flex align-items-start">
            
            <!-- Icon / Circle -->
            <div class="stepper-icon d-flex flex-column align-items-center mr-1">
              <!-- Saving / Loading Spinner -->
              <div class="step-circle saving d-flex align-items-center justify-content-center" *ngIf="onboardingService.savingStepIndex === i">
                <div class="spinner-border spinner-border-sm text-primary" role="status" style="width: 12px; height: 12px; border-width: 2px;"></div>
              </div>
              <!-- Completed -->
              <div class="step-circle completed" *ngIf="onboardingService.savingStepIndex !== i && i < onboardingService.completedStepIndex">
                <i class="feather icon-check text-white" style="font-size: 12px;"></i>
              </div>
              <!-- Current active tour step -->
              <div class="step-circle current" *ngIf="onboardingService.savingStepIndex !== i && i === onboardingService.currentStep"></div>
              <!-- Upcoming / Incomplete -->
              <div class="step-circle upcoming" *ngIf="onboardingService.savingStepIndex !== i && i >= onboardingService.completedStepIndex && i !== onboardingService.currentStep"></div>
              
              <!-- Line Connector -->
              <div class="step-line" *ngIf="i < onboardingService.steps.length - 1"></div>
            </div>

            <!-- Text Content -->
            <div class="stepper-content flex-grow-1 pb-1">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="fw-bolder mb-0" [ngStyle]="{'color': i < onboardingService.completedStepIndex ? '#28c76f' : (i === onboardingService.currentStep ? '#1E1E2D' : '#6E6B7B')}" style="font-size: 13px;">{{ step.itemName }}</h6>
                  <span class="text-primary fw-bold" style="font-size: 11px;" *ngIf="onboardingService.savingStepIndex === i">Saving...</span>
                  <span class="text-success fw-bold" style="font-size: 11px;" *ngIf="onboardingService.savingStepIndex !== i && i < onboardingService.completedStepIndex">Completed</span>
                  <span class="text-primary" style="font-size: 11px;" *ngIf="onboardingService.savingStepIndex !== i && i === onboardingService.currentStep">Current step</span>
                  <span class="text-muted" style="font-size: 11px;" *ngIf="onboardingService.savingStepIndex !== i && i >= onboardingService.completedStepIndex && i !== onboardingService.currentStep">Step {{ i + 1 }} of {{ onboardingService.steps.length }}</span>
                </div>
                <i class="feather icon-chevron-right text-muted" style="font-size: 14px;"></i>
              </div>
            </div>
            
          </div>
        </ng-container>
      </div>

      <!-- Action Button -->
      <button class="btn btn-primary w-100" style="border-radius: 8px; font-weight: 600; padding: 10px;" (click)="onboardingService.resume()">
        Continue setup <i class="feather icon-arrow-right ml-50"></i>
      </button>

    </div>
  </div>
